export default __webpack_public_path__ + "static/media/siderail-down-demo.89e1a577.png";